import React, { useRef } from "react";
import "./placeDetails.css";

import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import car from "../../images/icons/car.png";
import InputBox from "../commonComponents/inputComponents/InputBox";
import LicensePlateInput from "./LicensePlateInput";

import { Link } from "react-router-dom";
import { toast } from "react-toastify";

import { useNavigate } from "react-router-dom";

import { useShipping } from "../../contexts/ShippingContext";

export default function InCarDetail() {
  const navigate = useNavigate();

  const carIdFirstTwoStringRef = useRef();
  const carIdMiddleStringRef = useRef();
  const carIdLastThreeStringRef = useRef();
  const carIdPlaceRef = useRef();
  const carColorRef = useRef();
  const carModelRef = useRef();

  const { addDeliveryInfo } = useShipping();

  function handleSubmit(e) {
    e.preventDefault();
    const carIdFirstTwoString = carIdFirstTwoStringRef.current.value;
    const carIdMiddleString = carIdMiddleStringRef.current.value;
    const carIdLastThreeString = carIdLastThreeStringRef.current.value;
    const carIdPlace = carIdPlaceRef.current.value;
    const carColor = carColorRef.current.value;
    const carModel = carModelRef.current.value;

    if (
      !carIdFirstTwoString ||
      !carIdMiddleString ||
      !carIdLastThreeString ||
      !carIdPlace ||
      !carColor ||
      !carModel
    ) {
      return toast.error("لطفا اطلاعات را وارد کنید");
    }

    if (
      isNaN(carIdFirstTwoString) ||
      isNaN(carIdLastThreeString) ||
      isNaN(carIdPlace)
    ) {
      return toast.error("لطفا شماره پلاک صحیح را وارد کنید");
    }

    addDeliveryInfo("CAR", {
      car_id_first_two_string: carIdFirstTwoString,
      id_middle_string: carIdMiddleString,
      id_last_three_string: carIdLastThreeString,
      car_id_place: carIdPlace,
      car_color: carColor,
      car_model: carModel,
    });
    navigate("/shipping/location");
  }

  return (
    <div className="detail-main-container">
      <div className="place-detail-text">
        <h2 className="middle-box-header">من اینجا..</h2>
        <div className="place-item detail-item">
          <span className="place-item-icon">
            <img src={car} alt="" className="detail-car" />
          </span>
          با ماشین هستم
        </div>

        <Link to="/shipping/type" className="detail-return-link">
          <span className="return-text detail-return-text">
            بازگشت
            <FontAwesomeIcon icon={faChevronLeft} className="return-icon" />
          </span>
        </Link>
      </div>
      <div className="detail-information">
        <form action="" className="detail-info-form" onSubmit={handleSubmit}>
          <LicensePlateInput
            ref={{
              carIdFirstTwoStringRef: carIdFirstTwoStringRef,
              carIdMiddleStringRef: carIdMiddleStringRef,
              carIdLastThreeStringRef: carIdLastThreeStringRef,
              carIdPlaceRef: carIdPlaceRef,
            }}
          />
          <InputBox gap="15px" label="مدل" ref={carModelRef} />
          <InputBox gap="30px" label="رنگ" ref={carColorRef} />
          <button className="red-submit-btn detail-submit-btn">ثبت</button>
        </form>
      </div>
    </div>
  );
}
